import BaseComponent from "../../../baseComponent.js";

export default class Studios extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleDragStart(e) {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("data", JSON.stringify(this.props.dataset));
    e.dataTransfer.setData("type", "dataset");
  }

  handleDragEnd() {
  }

  render() {
    return (
      <div className="studio-search-dataset" draggable="true"
           onDragStart={this.handleDragStart}
           onDragEnd={this.handleDragEnd}>
        <span className="add-widget-dataset__name">{this.props.dataset.name}</span>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/analytic-studio/editor/header/dataset.jsx